import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Img as ZinniaImg } from '@zapier/design-system';
export function Img(props) {
    var _a;
    return props.src ? (_jsx(ZinniaImg, Object.assign({}, props, { isFullWidth: (_a = props.isFullWidth) !== null && _a !== void 0 ? _a : true }))) : null;
}
//# sourceMappingURL=Img.js.map